interface WindowInterface extends Window {
  dataLayer: object[];
}

declare let window: WindowInterface;

export default class WindowService {
  public static pushToDatalayer(event: object) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(event);
  }
}
